import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, Typography } from "@mui/material";
import TheatersOutlinedIcon from '@mui/icons-material/TheatersOutlined';
import { isMobile } from "react-device-detect";
import PropTypes from "prop-types";

const SliderCarteleria = (props) => {
  const { slides } = props;
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { arrows: false },
      },
      {
        breakpoint: 768,
        settings: { arrows: false, dots: false },
      },
    ],
  };

  return (
    <Box
      sx={{
        marginTop: "20px",
        height: "30vh",
        maxWidth: "100vw",
        marginBottom: "2rem",
      }}
    >
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              width: "100%",
              height: "30vh",
              borderRadius: "4px"             
            }}
          >
            {/* Imagen de fondo con overlay */}
            <Box
              component="img"
              src={slide.imagen}
              alt={`Imagen ${index + 1}`}
              sx={{
                width:!isMobile ? "96%": '100%',
                height: "100%",
                objectFit: "cover",
                position: "absolute",
                top: 0,
                left: !isMobile ? '.5rem': 0,
                borderRadius: "4px",


              }}
            />
            {/* Overlay */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: !isMobile ? '.5rem': 0,
                width:!isMobile ? "96%": '100%',
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                borderRadius: "4px",

                /*   padding: '20px' */
              }}
            >
              <Box
                sx={{
                  top: 0,
                  width: "96%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
              >
                
                <Typography
                  variant="h4"
                   textTransform="uppercase"
                  sx={{ fontSize: isMobile ? "1.6rem" : "2rem" }}
                  fontWeight="bold"
                >
                  {slide.titulo}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Slider>
    </Box>
  );

  // eslint-disable-next-line no-unreachable
  SliderCarteleria.propTypes = {
    slides:PropTypes.shape({
    imagen: PropTypes.string,
    ttulo: PropTypes.string
  }),
  };
};

export default SliderCarteleria;
